
import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Drawer = ({ isOpen, onClose, title, children, size = 'md', hideCloseButton = false }) => {
    // Prevent body scroll when drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const sizeClasses = {
        sm: 'max-w-md',
        md: 'max-w-xl',
        lg: 'max-w-3xl',
        xl: 'max-w-5xl',
        full: 'max-w-full',
    };

    return (
        <div className="fixed inset-0 z-50 overflow-hidden" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
            <div className="absolute inset-0 overflow-hidden">
                {/* Backdrop */}
                <div
                    className="absolute inset-0 bg-gray-500 bg-opacity-75 pt-0 mt-0 transition-opacity"
                    aria-hidden="true"
                    onClick={onClose}
                ></div>

                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                    <div className={`pointer-events-auto w-screen ${sizeClasses[size] || sizeClasses.md} transform transition ease-in-out duration-500 sm:duration-700 bg-white shadow-xl flex flex-col`}>
                        {/* Header */}
                        {(title || !hideCloseButton) && (
                            <div className="flex items-start justify-between px-4 py-6 sm:px-6 border-b border-gray-200">
                                {title && (
                                    <h2 className="text-lg font-medium text-gray-900" id="slide-over-title">
                                        {title}
                                    </h2>
                                )}
                                {!hideCloseButton && (
                                    <div className="ml-3 flex h-7 items-center">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#0F2942]/50 focus:ring-offset-2"
                                            onClick={onClose}
                                        >
                                            <span className="sr-only">Close panel</span>
                                            <X className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Content */}
                        <div className="relative flex-1 px-4 py-6 sm:px-6 overflow-y-auto">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drawer;
